import { createSlice } from "@reduxjs/toolkit";

const mySlice = createSlice({
  name: "layout",
  initialState: {
    currentSettingTab: "discount",
    appointmentDate: null,
  },
  reducers: {
    setCurrentSettingTab(state, action) {
      state.currentSettingTab = action.payload;
    },
    setAppointmentDate(state, action) {
      state.appointmentDate = action.payload;
    },
  },
});

export const myLayoutActions = mySlice.actions;

export default mySlice.reducer;
